const generatePrintInvoiceHTML = (invoice) => {
  const finalAmount = invoice.finalAmount || invoice.totalAmount;
  const discount = invoice.discount || 0;
  
  // Extract user and restaurant from populated invoice
  const user = invoice.userId;
  const restaurant = invoice.restaurantId;

  return `
    <html>
      <head>
        <title>Invoice - ${invoice.invoiceNumber}</title>
        <style>
          /* Print-specific styles */
          @page {
            size: auto; /* Auto size for thermal paper */
            margin: 0; /* No margin to maximize space */
          }
          body {
            font-family: Arial, sans-serif;
            font-size: 10px; /* Smaller font size for compact layout */
            line-height: 1.2; /* Tight line spacing */
            margin: 0;
            padding: 0;
            color: #000; /* Black text for thermal printers */
            background: #fff; /* White background */
          }
          .invoice-print-container {
            width: 100%;
            max-width: 80mm; /* Adjust for 58mm or 80mm paper */
            margin: 0 auto;
            padding: 5px; /* Minimal padding */
          }
          .invoice-print-header {
            text-align: center;
            margin-bottom: 5px;
          }
          .invoice-print-header h2 {
            font-size: 14px; /* Slightly larger for headings */
            margin: 0;
            color: #000;
          }
          .invoice-print-header p {
            font-size: 10px;
            margin: 3px 0;
            color: #000;
          }
          .invoice-print-company {
            text-align: center;
            margin-bottom: 5px;
          }
          .invoice-print-company h3 {
            font-size: 12px;
            margin: 0 0 3px 0;
            color: #000;
          }
          .invoice-print-company p {
            font-size: 10px;
            margin: 2px 0;
            color: #000;
          }
          .invoice-print-user {
            margin-bottom: 5px;
            padding: 5px 0;
            border-top: 1px dashed #000; /* Dashed border for separation */
            border-bottom: 1px dashed #000;
          }
          .invoice-print-user h5 {
            font-size: 12px;
            margin: 0 0 3px 0;
            color: #000;
          }
          .invoice-print-user p {
            font-size: 10px;
            margin: 2px 0;
            color: #000;
          }
          .invoice-print-food {
            margin-bottom: 5px;
          }
          .invoice-print-food h5 {
            font-size: 12px;
            margin: 0 0 3px 0;
            color: #000;
          }
          .invoice-print-food table {
            width: 100%;
            border-collapse: collapse;
            margin-bottom: 5px;
          }
          .invoice-print-food th,
          .invoice-print-food td {
            padding: 3px;
            text-align: left;
            border-bottom: 1px dashed #000; /* Dashed border for table rows */
          }
          .invoice-print-food th {
            font-weight: bold;
            background-color: #f0f0f0; /* Light gray background for headers */
          }
          .invoice-print-tax {
            margin-bottom: 5px;
          }
          .invoice-print-tax .invoice-print-total {
            display: flex;
            justify-content: space-between;
            font-size: 10px;
            margin-bottom: 3px;
          }
          .invoice-print-final {
            font-size: 12px;
            font-weight: bold;
            display: flex;
            justify-content: space-between;
            margin-top: 5px;
            padding-top: 5px;
            border-top: 2px solid #000; /* Solid border for emphasis */
          }
          .invoice-print-footer {
            text-align: center;
            font-size: 10px;
            color: #000;
            margin-top: 5px;
          }
          .invoice-payment-info {
            margin-top: 5px;
            padding-top: 5px;
            border-top: 1px dashed #000;
            text-align: center;
            font-weight: bold;
          }
        </style>
      </head>
      <body>
        <div class="invoice-print-container">
          <div class="invoice-print-header">
            ${(restaurant?.logo && restaurant?.invoiceSettings?.showLogo !== false) ? `
              <div style="text-align: center; margin-bottom: 10px;">
                <img src="${restaurant.logo}" alt="Logo" style="max-width: 200px; max-height: 120px; object-fit: contain;" />
              </div>
            ` : ''}
            <h2>${restaurant?.name || 'TastyFlow'}</h2>
            <p>Invoice No: ${invoice.invoiceNumber}</p>
            <p>Date: ${new Date(invoice.invoiceDate || new Date()).toLocaleDateString()} ${new Date(invoice.invoiceDate || new Date()).toLocaleTimeString([], {hour: '2-digit', minute:'2-digit'})}</p>
            ${invoice.tableNumber ? `<p><strong>Table No:</strong> ${invoice.tableNumber}</p>` : ''}
            ${(invoice.reservedTableInfo && invoice.reservedTableInfo.length > 0) ? `<p><strong>Linked Reservations:</strong> ${invoice.reservedTableInfo.map(r => `T${r.tableNumber}`).join(', ')}</p>` : ''}
          </div>

          ${restaurant?.invoiceSettings?.headerText ? `
            <div style="text-align: center; margin-bottom: 10px; border: 1px solid #000; padding: 5px; font-weight: bold;">
              ${restaurant.invoiceSettings.headerText}
            </div>
          ` : ''}

          ${restaurant?.invoiceSettings?.contactVisible !== false ? `
            <div class="invoice-print-company">
              <h3>Restaurant Details</h3>
              <p>${restaurant?.location || 'Shlok Infinity, 1st Floor, Sundersingh Bhandari Overbridge, Opposite Vishvakarma Temple'}</p>
              <p>Phone: ${restaurant?.contactNumber || '(909) 91-49101'}</p>
            </div>
          ` : ''}

          <div class="invoice-print-user">
            <h5>Bill To:</h5>
            <p><strong>Name:</strong> ${user ? user.name : 'Walk-in Guest'}</p>
            ${user && user.contact ? `<p><strong>Contact:</strong> ${user.contact}</p>` : ''}
          </div>

          ${(invoice.reservedTableInfo && invoice.reservedTableInfo.length > 0) ? `
          <div class="invoice-print-reservation" style="margin-bottom: 5px; padding: 5px 0; border-bottom: 1px dashed #000;">
            <h5 style="font-size: 12px; margin: 0 0 3px 0; color: #000;">Reservation Details:</h5>
            ${invoice.reservedTableInfo.map(r => `
              <p style="font-size: 10px; margin: 2px 0;"><strong>Table:</strong> ${r.tableNumber} | <strong>Date:</strong> ${new Date(r.date || new Date()).toLocaleDateString()} | <strong>Slot:</strong> ${r.slotTime}</p>
            `).join('')}
          </div>
          ` : ''}

          <div class="invoice-print-food">
            <h5>Items Purchased</h5>
            <table>
              <thead>
                <tr>
                  <th>Item</th>
                  <th style="text-align: center;">Qty</th>
                  <th style="text-align: right;">Price</th>
                  <th style="text-align: right;">Total</th>
                </tr>
              </thead>
              <tbody>
                ${invoice.foods.map((food, index) => `
                  <tr>
                    <td>${food.name}</td>
                    <td style="text-align: center;">${food.quantity}</td>
                    <td style="text-align: right;">${(food.price || 0).toFixed(2)}</td>
                    <td style="text-align: right;">${((food.quantity || 0) * (food.price || 0)).toFixed(2)}</td>
                  </tr>
                `).join('')}
              </tbody>
            </table>
          </div>

          <div class="invoice-print-tax">
            <div class="invoice-print-total"><span>CGST (2.5%):</span> <span>₹${(invoice.cgst || 0).toFixed(2)}</span></div>
            <div class="invoice-print-total"><span>SGST (2.5%):</span> <span>₹${(invoice.sgst || 0).toFixed(2)}</span></div>
            ${discount > 0 ? `<div class="invoice-print-total"><span>Discount:</span> <span>-₹${discount.toFixed(2)}</span></div>` : ''}
            ${(invoice.reservedTableInfo && invoice.reservedTableInfo.some(info => info.status === 'succeeded')) ? `<div class="invoice-print-total"><span>Reservation Advance:</span> <span>-₹100.00</span></div>` : ''}
            ${Math.abs(invoice.roundOff || 0) > 0.01 ? `<div class="invoice-print-total"><span>Round-off:</span> <span>₹${(invoice.roundOff || 0).toFixed(2)}</span></div>` : ''}
          </div>

          <div class="invoice-print-final">
            <div>Total Payable:</div>
            <div>₹${finalAmount.toFixed(2)}</div>
          </div>
          
          <div class="invoice-payment-info">
            Payment Method: ${(invoice.payments && invoice.payments[0]?.paymentMethod || 'CASH').toUpperCase()}
          </div>
          
          <div style="text-align: center; margin-top: 5px; font-size: 10px;">
             ${amountInWords(finalAmount)}
          </div>

          <div class="invoice-print-footer">
            <p>${restaurant?.invoiceSettings?.footerText || 'Thank you for dining with us!'}</p>
            <p style="margin-top: 8px; font-size: 8px; color: #555; font-style: italic;">Powered by TastyFlow POS</p>
          </div>
        </div>
      </body>
    </html>
  `.trim();
};

/**
 * Convert amount to words for Indian numbering system
 */
const amountInWords = (amount) => {
    const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine', 'Ten',
        'Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
    const tens = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const convertGroup = (num) => {
        if (num < 20) return units[num];
        if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + units[num % 10] : '');
        if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + convertGroup(num % 100) : '');
        return '';
    };

    const convert = (num) => {
        if (num === 0) return 'Zero';
        let result = '';
        if (Math.floor(num / 10000000) > 0) {
            result += convertGroup(Math.floor(num / 10000000)) + ' Crore ';
            num %= 10000000;
        }
        if (Math.floor(num / 100000) > 0) {
            result += convertGroup(Math.floor(num / 100000)) + ' Lakh ';
            num %= 100000;
        }
        if (Math.floor(num / 1000) > 0) {
            result += convertGroup(Math.floor(num / 1000)) + ' Thousand ';
            num %= 1000;
        }
        if (num > 0) {
            result += convertGroup(num);
        }
        return result.trim();
    };

    const roundedAmount = Math.round(amount);
    if (roundedAmount === 0) return 'Zero Rupees Only';
    return convert(roundedAmount) + ' Rupees Only';
};

export default generatePrintInvoiceHTML;
